var map = {
	"./blue.min.css": [
		841,
		32
	],
	"./kantipur777.css": [
		842,
		33
	],
	"./pkspin.css": [
		843,
		34
	],
	"./root.css": [
		844,
		35
	],
	"./root9loonbet.css": [
		845,
		36
	],
	"./rootHk.css": [
		846,
		37
	],
	"./rootIndia.css": [
		847,
		38
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 792;
module.exports = webpackAsyncContext;